import { TextField, TextFieldProps, styled } from '@mui/material'
import React from 'react'

interface CustomTextFieldInterface {
    /**
     * isSmall - if true, the text field will be smaller (4.5px padding instead of 8.5px)
     * @default false
     * @type {boolean}
     * @memberof CustomTextFieldInterface
     */
    isSmall?: boolean
    isPaddingDisabled?: boolean
    textSize?: number
    autoComplete?: string
}

type CustomTextFieldProps = TextFieldProps & CustomTextFieldInterface

// This is necessary because paddingSize moved label and this centers it again
const StyledTextField = styled(TextField)(({ theme }) => ({
    backgroundColor: theme.palette.customBackground.default,
    '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 8px)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px, -9px) scale(0.75)',
    },
}));

const CustomTextField: React.FC<CustomTextFieldProps> = ({
    isSmall,
    isPaddingDisabled,
    textSize,
    autoComplete='off',
    ...props
}: CustomTextFieldProps) => {
    const paddingSize = isPaddingDisabled ? 0 : props.multiline ? '0' : !isSmall ? '6.5px 14px' : '4.5px 12px'

    return (
        <StyledTextField
            autoComplete={autoComplete}
            {...props}
            variant='outlined'
            sx={props.style}
            inputProps={{
                style: {
                    padding: paddingSize,
                    fontSize: textSize ? textSize : 16,
                },
                ...props.inputProps,
            }}
        />
    )
}

export default CustomTextField
